/**
 * @generated SignedSource<<5ba6a4e34aecf005bc4af17662eedbf9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification$data = {
  readonly dailyDueDateNotification: {
    readonly id: string;
    readonly slackChannel: {
      readonly isEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification";
};
export type slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification$key = {
  readonly " $data"?: slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification$data;
  readonly " $fragmentSpreads": FragmentRefs<"slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification",
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "dailyDueDateNotification",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "dailyDueDateNotification.id"
        },
        {
          "concreteType": "JiraNotificationChannel",
          "kind": "LinkedField",
          "name": "slackChannel",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNotificationPreferences"
};

(node as any).hash = "6021938a32dc3367dd7ef33f5e5d30b9";

export default node;
